import styled from 'styled-components';
import C from '@assets/themes/colors';

interface IRootProps {
  backgroundColor?: string;
  hoverBackgroundColor?: string;
}
export const Root = styled.div`
  display: flex;
  padding: 10px 12.6px 10px 13.4px;
  background-color: ${(props: IRootProps) => props.backgroundColor ? props.backgroundColor : C.DARK_BLUE};
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 3px;
  box-shadow: 4px 4px 10px 0 rgba(0, 0, 0, 0.05);
  &:hover {
    background-color: ${(props: IRootProps) => props.hoverBackgroundColor ? props.hoverBackgroundColor : C.DARK_BLUE};
  }
`

export const Text = styled.span`
  font-family: Roboto;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: ${C.WHITE};
`